module.exports = __webpack_public_path__ + "static/media/avatar.bb580299.jpg";